import SEO, { breadcrumbSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { TourCard, SectionHead } from "../components/Cards";
import { TOURS, ALL_IMAGES } from "../data/content";
import { TOURS_HI } from "../data/hindi";
import { useLang } from "../i18n";
import Reveal from "../components/Reveal";

export default function Tours() {
  const { lang, t } = useLang();
  const tours = TOURS.map((tour, i) => (lang === "hi" && TOURS_HI[i] ? { ...tour, ...TOURS_HI[i] } : tour));

  return (
    <>
      <SEO
        title="Rajasthan Tour Packages by Taxi — From Jodhpur"
        description="Rajasthan tour packages with private taxi & driver: Jodhpur sightseeing, Jaisalmer desert tour, Udaipur lakes, Golden Triangle, heritage & complete Rajasthan circuits. Request a quote."
        path="/tour-packages"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Tour Packages", path: "/tour-packages" }])]}
      />
      <PageHero
        title={t("pTourTitle")}
        subtitle={t("pTourSub")}
        image={ALL_IMAGES.desertSunset}
        crumbs={[{ label: "Home", to: "/" }, { label: t("navTours") }]}
      />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <SectionHead eyebrow={t("pTourEyebrow")} title={t("pTourHead")} text={t("pTourText")} />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tours.map((tour, i) => <TourCard key={tour.name} t={tour} i={i} />)}
        </div>
        <Reveal className="mt-10 max-w-2xl mx-auto text-center">
          <p className="text-sm text-slate-500">{t("tourNote")}</p>
        </Reveal>
      </section>
      <CtaBand />
    </>
  );
}
